import React from "react";
import css from "./SectionView.module.css";
import FieldView from "./FieldView/FieldView";
import {FileView} from "Components";


export default function SectionView(props){
    const {title,code,fields,onMount}=props;
    return (
        <div 
            className={`${css.sectionview} ${props.className||""}`} 
            style={{marginTop:`${title?"calc(1 * var(--spacing))":"0"}`,...props.style}}
        >
            {title&&
                <h3 className={css.title}>{title}</h3>
            }
            {fields&&fields.map((field,i)=>
                <FieldView key={(field.name||"")+i} field={field}/>
            )}
            {(code||onMount)&&(
                <div className={css.container} ref={onMount}>
                    {code&&<FileView content={code}/>}
                </div>
            )}
        </div>
    )
}
